//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import styled from 'styled-components';

/**
 * A Full width Horizontal Rule
 */
export const HR = styled.div(
  ({ theme }) => `
  border-top: ${theme.borderWidths[1]} solid ${theme.colors.gray2};
`,
);

/**
 * This style adds a bottom margin of 16px. Because this style is a formal design consideration,
 * we're exporting it for the sake of consistency and usability.
 */
export const HrWithMargin = styled(HR)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
`,
);

export default HR;
